/**
 * Is object empty?
 * @param  obj
 * @return {Boolean}
 */
export function isEmpty(obj) {
	if (obj == null) return true;
	if (obj.length > 0) return false;
	if (obj.length === 0) return true;
	if (Object.getOwnPropertyNames(obj).length > 0) return false;
	return true;
}

/**
 * Serialize an object into a query string
 * credit: http://stackoverflow.com/a/1714899
 * @param obj
 * @param prefix
 * @returns {string}
 */
export function serialize(obj, prefix) {
	let str = [];
	let p;
	for (p in obj) {
		if (Object.prototype.hasOwnProperty.call(obj, p)) {
			let k = prefix ? prefix + "[" + p + "]" : p;
			let v = obj[p];
			str.push((v !== null && typeof v === "object") ?
				serialize(v, k) :
				encodeURIComponent(k) + "=" + encodeURIComponent(v));
		}
	}
	return str.join("&");
}
